import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { GetRasterCategoriesFiltered$Params } from 'src/app/server-api/fn/raster-category-controller/get-raster-categories-filtered';
import { RasterCatCode, RasterCategoryFilterDto } from 'src/app/server-api/models';
import { RasterCategoryControllerService } from 'src/app/server-api/services';
import { ListComponent } from 'src/app/utils-flc/list/list.component';

@Component({
  selector: 'app-raster-categories-list',
  templateUrl: './raster-categories-list.component.html',
  styleUrls: ['./raster-categories-list.component.css']
})
export class RasterCategoriesListComponent extends ListComponent {

  constructor(public override translate: TranslateService, public override sidenavService: SideNavService, private rasterCategoriesService: RasterCategoryControllerService) {
      super(translate, sidenavService);

      this.constructorName = 'RasterCategoriesList';
    }

  override ngOnInit(): void {

    this.placeholderSearchText = 'raster-categories.search';
    this.exportPrefix = 'system-params_';
    this.profilesAllowEdit = 'ADMIN';

    super.ngOnInit();
  }

  override initAfterRoutePath()
  {

    this.translate
    .get(['raster-category.button_create', 'icon_refresh', 'action_show', "raster-category.code"
  ])
  .subscribe((translations: string[]) => {
    this.translations = translations;
    this.topMenuIcons = [
      {icon: "add", title: translations['raster-category.button_create'], routerLink: RouterLinkEnum.RASTER_CATEGORIES.toString() + "new", clickMethod: "dummy", checkDisable:true},
      {icon: "refresh", title: translations['icon_refresh'], routerLink: null, clickMethod: "refresh"}
    ];
    this.actions = [
      {icon: "playlist_add", title: translations['action_show'], routerLink: RouterLinkEnum.RASTER_CATEGORIES.toString(), clickMethod: "dummy"}
    ];

    this.displayedColumns = ['actions', 'name', 'code','colorMap'];
    this.filterFields = ['', translations['raster-category.code']];
  });
  }

  override getItems() {
    super.getItems();

    let filterRequest: string = this.filter ? this.filter.nativeElement.value : '';
    let bodyRequest:RasterCategoryFilterDto = {  };
    for (let filter of this.filters)
    {
       if (filter.field === '') filterRequest = filter.value;
       if (filter.field === this.translations['raster-category.code']) bodyRequest.code = this.getCategoryType(filter.value);
    }

    let request:GetRasterCategoriesFiltered$Params = {
      page: this.paginator.pageIndex,
      size: this.paginator.pageSize,
      sort: [this.dataSource.sort.active + ',' + this.dataSource.sort.direction],
      filter: filterRequest,
      body: bodyRequest
    };
    this.rasterCategoriesService.getRasterCategoriesFiltered(request).subscribe(
      value  => {
        this.dataSource.data = value['content'];
        this.listIds = this.dataSource.data.map(d => d.id);
        this.totalElements = value['totalElements'];
        this.sidenavService.setLoading(false);
      }
    ,
      error => {
        console.error(JSON.stringify(error));
        this.sidenavService.setLoading(false);
      }
        ,
      () => {
        this.sidenavService.setLoading(false);
      }
    );
  }

  getCategoryType(code: string)
  {
    var keys = Object.keys(RasterCatCode);
    var result: RasterCatCode;

    keys.forEach((obj, index) => {
      if (code.toUpperCase() === obj.toUpperCase()) {
        result = RasterCatCode[obj];
      }
    });
    return result;
  }

}



